// extracted by mini-css-extract-plugin
export default {"template-card-container":"LetterTemplateCardsContainer_template-card-container__zzJfJ"};